export default "__VITE_ASSET__db8c837d__"